import { render } from "./productDetailMultiSubOption.vue?vue&type=template&id=072553b1&scoped=true"
import script from "./productDetailMultiSubOption.vue?vue&type=script&lang=js"
export * from "./productDetailMultiSubOption.vue?vue&type=script&lang=js"

import "./productDetailMultiSubOption.vue?vue&type=style&index=0&id=072553b1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072553b1"]])

export default __exports__